import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { FormlyModule } from '@ngx-formly/core';

import { DirectivesModule } from '@directives/directives.module';

import { TaInputComponent } from './ta-input.component';

import { RequiredValidator } from '../ta-validators';

@NgModule({
    declarations: [TaInputComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        DirectivesModule,
        FormlyModule.forChild({
            types: [
                {
                    name: 'ta-input',
                    component: TaInputComponent,
                    defaultOptions: {
                        validators: {
                            required: RequiredValidator,
                        }
                    }
                }
            ]
        })
    ]
})
export class TaFormlyInputModule { }
